import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import React from 'react';
import {
  individual_column_style,
  individual_header_style
} from 'assets/styles/table_custom_style';
import FlexTable from 'components/FlexTable';
import { TimeLineStageLeadModal } from './TimeLine/TimeLineStageLeadModal';

export const AnalyticalOpportunityTime = ({
  data,
  sortConfig,
  setSortConfig
}) => {
  const createDynamicColumns = () => {
    const columns = [];

    columns.push(
      {
        dataField: 'title',
        text: 'Título da Oportunidade',
        sort: true,
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_cell, { title }) => title
      },
      {
        dataField: 'initial_stage',
        text: 'Fase inicial',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_cell, { initial_stage }) => initial_stage
      },
      {
        dataField: 'initial_moved_at',
        text: 'Data da mudança',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_cell, { initial_moved_at }) => initial_moved_at
      },
      {
        dataField: 'initial_stage_time',
        text: 'Dias na fase',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_cell, { initial_stage_time }) => initial_stage_time
      },
      {
        dataField: 'initial_moved_at_time',
        text: 'Dentro do prazo',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_cell, { initial_moved_at_time }) => initial_moved_at_time
      },
      {
        dataField: 'current_stage',
        text: 'Fase atual',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_cell, { current_stage }) => current_stage
      },
      {
        dataField: 'current_moved_at',
        text: 'Data da mudança',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_cell, { current_moved_at }) => current_moved_at
      },
      {
        dataField: 'current_stage_time',
        text: 'Dias na fase',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_cell, { current_stage_time }) => current_stage_time
      },
      {
        dataField: 'current_moved_at_time',
        text: 'Dentro do prazo',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_cell, { current_moved_at_time }) => current_moved_at_time
      },
      {
        dataField: 'stage_changes',
        text: 'info',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (cell, row) => (
          <span>
            <TimeLineStageLeadModal
              stageChanges={row?.stage_changes}
              title={row?.title}
              currentStage={row?.current_stage}
              responsible={row?.responsibleName}
            />
          </span>
        )
      }
    );

    return [...columns];
  };

  const dynamicFunctionColumns = createDynamicColumns();

  return (
    <ToolkitProvider
      data={data || []}
      keyField="id"
      columns={dynamicFunctionColumns}
    >
      {(props) => (
        <div className="py-4 table-responsive">
          <FlexTable
            entityName="opportunityTime"
            bootstrap4={true}
            bordered={false}
            classes="align-items-center"
            setSortConfig={setSortConfig}
            sortConfig={sortConfig}
            {...props.baseProps}
          />
        </div>
      )}
    </ToolkitProvider>
  );
};
